<template>
  <v-dialog @input="close" :value="isOpened" max-width="500px">
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title class="font-weight-bold">
          {{ dialogTitle }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn @click="close" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="px-3">
        <v-form ref="form">
          <v-container>
            <v-row dense>
              <v-col cols="12">
                <v-text-field
                  v-model="updates.name"
                  :disabled="isLoading"
                  :label="`${$t('generalAttributes.name')}*`"
                  :rules="[requiredStringRule]"
                  counter="256" />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="updates.label"
                  :disabled="isLoading"
                  :label="`${$t('entities.cashRegisters.attributes.label')}*`"
                  :rules="[requiredStringRule]"
                  counter="256" />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions class="py-4">
        <v-btn @click="close" text class="ml-2">
          {{ $t('miscellaneous.cancel') }}
        </v-btn>
        <v-spacer />
        <v-btn
          @click="submit"
          :disabled="isLoading"
          :loading="isLoading"
          class="mr-2"
          color="primary">
          {{ $t('miscellaneous.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const resetUpdates = (data = {}) => ({
  id: data.id || '',
  name: data.name || '',
  label: data.label || '',
})

export default {
  name: 'CashRegisterUpsertDialog',
  props: {
    cashRegister: { type: Object, default: () => ({}) },
    isLoading: { type: Boolean, default: false },
    isOpened: { type: Boolean, required: true },
  },
  data() {
    return {
      updates: resetUpdates(),
    }
  },
  computed: {
    dialogTitle() {
      return this.cashRegister.id
        ? this.$t('entities.cashRegisters.editEntity')
        : this.$t('entities.cashRegisters.newEntity')
    },
    requiredStringRule() {
      return (v) =>
        (!!v && v.length >= 1 && v.length <= 256) ||
        'Required (1-256 characters).'
    },
  },
  methods: {
    close() {
      return this.$emit('dialog:close')
    },
    onClose() {
      this.updates = resetUpdates()
      this.resetForm()
    },
    onOpen() {
      this.resetForm()
      this.updates = resetUpdates(this.cashRegister)
    },
    resetForm() {
      if (this.$refs.form) this.$refs.form.reset()
    },
    submit() {
      if (!this.$refs.form || !this.$refs.form.validate()) return
      return this.$emit('cash-register:upsert', { ...this.updates })
    },
  },
  watch: {
    isOpened(value) {
      return value ? this.onOpen() : this.onClose()
    },
  },
}
</script>
